import { render, staticRenderFns } from "./AuthoriseOtherLabourOld.vue?vue&type=template&id=1f6eb2b5&scoped=true"
import script from "./AuthoriseOtherLabourOld.vue?vue&type=script&lang=js"
export * from "./AuthoriseOtherLabourOld.vue?vue&type=script&lang=js"
import style0 from "./AuthoriseOtherLabourOld.vue?vue&type=style&index=0&id=1f6eb2b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6eb2b5",
  null
  
)

export default component.exports